/* eslint-disable @typescript-eslint/no-unsafe-call */
/* eslint-disable fp/no-mutation */
/* eslint-disable @typescript-eslint/no-unsafe-assignment */
import merge from 'lodash.merge';
import { commonMessages } from '../messages/common';
import { comparisonMessages } from '../messages/comparison';
import { comparisonTableMessages } from '../messages/comparison-table';
export const ComparisonTranslations = merge(undefined, commonMessages, comparisonMessages, comparisonTableMessages);
